/*
 * @description: 优惠券
 */
import { useState, useCallback } from 'react';
import type { CouponType } from '@/pages/order-center-order-confirm/type';
import { defaultCoupon } from '@/pages/order-center-order-confirm/type';

export default function OrderCenterSameCityCouponSelect() {
  const [selectedCoupon, setSelectedCoupon] = useState<CouponType>(
    defaultCoupon()
  );
  const [selectedGovtCoupon, setSelectedGovtCoupon] = useState<CouponType>(
    defaultCoupon()
  );

  const setSelectedCouponM = useCallback((val) => {
    setSelectedCoupon(val);
  }, []);
  const setSelectedGovtCouponM = useCallback((val) => {
    setSelectedGovtCoupon(val);
  }, []);

  // timestamp发生变化优惠券列表将会刷新
  const [couponListUpdateTimeStamp, setCouponListUpdateTimeStamp] = useState();

  const setCouponListUpdateTimeStampM = useCallback((val) => {
    setCouponListUpdateTimeStamp(val);
  }, []);

  //  清空数据
  const reset = useCallback(() => {
    setSelectedCoupon(defaultCoupon());
    setSelectedGovtCoupon(defaultCoupon());
  }, []);

  return {
    selectedCoupon,
    setSelectedCouponM,
    selectedGovtCoupon,
    setSelectedGovtCouponM,
    reset,
    couponListUpdateTimeStamp,
    setCouponListUpdateTimeStampM,
  };
}
